export default __webpack_public_path__ + "static/media/upload.7b67ed3d.svg";